module.exports = __webpack_public_path__ + "static/media/news-casestudy.f14ed0c8.jpg";